import { Box, Checkbox, Typography } from "@mui/material";
import React, { useState } from "react";
import convertCurrency, { convertIntMoney } from "src/helper/convertCurrency";
import useInventoryNoteList from "src/hooks/inventory/useInventoryNoteList";
import useQueryParams from "src/hooks/useQueryParams";
import { v4 as uuid } from "uuid";

export default function useAllFinanceBody({ wHouseId }) {
  const [option] = useQueryParams();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const { data: inventoryNote, isLoading } = useInventoryNoteList({
    limit: pagi?.limit,
    skip: pagi?.skip,
    warehouse: wHouseId,
    status: option?.tab,
  });

  const header = [
    {
      id: uuid(),
      title: "STT",
      align: "center",
      width: "20px",
    },
    {
      id: uuid(),
      align: "center",
      comp: <Checkbox />,
    },
    {
      id: uuid(),
      title: "Phiếu xuất",
      align: "center",
    },
    {
      id: uuid(),
      title: "Đối tượng",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tên Kho/ Nhân viên KD",
      align: "center",
    },
    {
      id: uuid(),
      title: "Trạng thái",
      align: "center",
    },
    {
      id: uuid(),
      title: "Số tiền thanh toán",
      align: "center",
    },
    {
      id: uuid(),
      title: "Mã ĐH/ Mã phiếu chuyển kho",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const bodyList = Array.isArray(inventoryNote?.data)
    ? inventoryNote?.data?.map((v, index) => ({
        ...v,
        no: index + 1,
        checkbox: <Checkbox />,
        actor: "N/A",
        name: "N/A",
        total: (
          <Box>
            <Typography>đ{convertIntMoney(v?.total)}</Typography>
            <Typography
              sx={{ fontWeight: "bold", fontSize: "12px", fontStyle: "italic" }}
            >
              {convertCurrency(v?.total)} đồng
            </Typography>
          </Box>
        ),
        transferCode: "N/A",
      }))
    : [];
  const sortData = [
    "no",
    "checkbox",
    "code",
    "actor",
    "name",
    "status",
    "total",
    "transferCode",
  ];
  return { header, sortData, bodyList, isLoading };
}
